import * as React from "react"

import { cn } from "../../../lib/utils"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-[10px] border border-[color:var(--ws-line)] bg-[color:var(--ws-surface)] px-3 py-2 text-sm shadow-[var(--ws-shadow-xs)] transition-[border-color,box-shadow] file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-[color:var(--ws-ink-4)] hover:border-[color:var(--ws-line-strong)] focus-visible:outline-none focus-visible:border-[color:var(--ws-blue-line)] focus-visible:shadow-[var(--ws-ring)] disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }